export const logError = (...args) => {
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV !== "production") console.warn(...args);
};
